const API_BASE = "";

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      ...(init?.headers || {}),
    },
    ...init,
  });
  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || `Request failed: ${response.status}`);
  }
  return response.json();
}

export type LocalSessionResponse = {
  assessment_id: string;
  participant_id: string;
  game_id: string;
  quest: string;
  is_new_participant: boolean;
  is_new_assessment: boolean;
  has_completed_before: boolean;
};

export const localApi = {
  auth: {
    getUser: async () => ({ user: { id: "local-user", email: "local@example.com" } }),
    signInWithPassword: (payload: any) => request<any>("/api/auth/login", { method: "POST", body: JSON.stringify(payload) }),
    signUp: (payload: any) => request<any>("/api/auth/signup", { method: "POST", body: JSON.stringify(payload) }),
    signOut: () => request<any>("/api/auth/logout", { method: "POST" }),
  },
  roles: (userId: string, role: string) => request<{ hasRole: boolean }>(`/api/roles/${userId}/${role}`),
  participants: {
    list: () => request<any[]>("/api/participants"),
    create: (body: any) => request<any>("/api/participants", { method: "POST", body: JSON.stringify(body) }),
    update: (id: string, body: any) => request<any>(`/api/participants/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  },
  assessments: {
    list: (query = "") => request<any[]>(`/assessment/get${query}`),
    create: (body: any) => request<any>("/assessment/create", { method: "POST", body: JSON.stringify(body) }),
    update: (id: string, body: any) => request<any>(`/assessment/update/${id}`, { method: "PUT", body: JSON.stringify(body) }),
  },
  session: (body: any) => request<LocalSessionResponse>("/assessment/create", { method: "POST", body: JSON.stringify(body) }),
  validate: (body: any) => request<any>("/assessment/validate", { method: "POST", body: JSON.stringify(body) }),
  stt: (body: any) => request<any>("/assessment/stt", { method: "POST", body: JSON.stringify(body) }),
  evaluate: (body: any) => request<any>("/assessment/evaluate", { method: "POST", body: JSON.stringify(body) }),
};
